import { Reveal } from "../Reveal";

export const PageHeader = ({ eyebrow, title, subtitle, image, testId }) => (
  <section data-testid={testId} className="relative overflow-hidden bg-navy text-white">
    {image && (
      <>
        <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/80 to-navy/40" />
      </>
    )}
    <div className="grain relative mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      <Reveal>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-aero">
            {eyebrow}
          </span>
        )}
        <h1 className="mt-6 max-w-3xl font-display text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70 lg:text-lg">{subtitle}</p>
        )}
      </Reveal>
    </div>
  </section>
);
